'use client';

import React, { useEffect } from 'react';
import { unstable_isUnrecognizedActionError } from 'next/navigation';
import { markServerActionSkew } from '@/app/lib/serverActionSkew';
import { ServerActionSkewReloadView } from '@/app/ui/ServerActionSkewDialog';
import Button from '@/ui/Button';

const unrecognizedSkewDetail = () => ({
	actionId: null,
	url: window.location.pathname,
	status: 404,
	detectedBy: 'header' as const,
});

export default function AppError({ error, reset }: { error: Error & { digest?: string }; reset: () => void }) {
	const isSkew = unstable_isUnrecognizedActionError(error);

	useEffect(() => {
		if (!isSkew) return;
		markServerActionSkew(unrecognizedSkewDetail());
	}, [isSkew]);

	if (isSkew) {
		return (
			<div className="flex min-h-screen items-center justify-center bg-primary-background p-6">
				<ServerActionSkewReloadView />
			</div>
		);
	}

	return (
		<div className="flex min-h-[50vh] flex-col items-center justify-center gap-4 text-grey-900">
			<h2 className="text-xl font-bold">Something went wrong</h2>
			<Button variant="contained" environment="light" onClick={() => reset()}>
				Try again
			</Button>
		</div>
	);
}
